module.exports = __webpack_public_path__ + "img/icon-element-Sword.87a26703.webp";